// NOTE: These keys are set on the `BASE_CONFIG` object by the z/z base Django template:
// https://github.com/zapier/zapier/blob/develop/web/backend/zapier/templates/base.html#L94-L95
// If you are using this component outside of z/z these need to be set explicitly

declare global {
  interface Window {
    BASE_CONFIG: Record<string, unknown> | null;
  }
}

export const apiKeys = {
  stripePubKey:
    typeof window !== "undefined"
      ? window.BASE_CONFIG?.stripePubApiKey ??
        process.env.STRIPE_PUB_API_KEY ??
        process.env.NEXT_PUBLIC_STRIPE_PUB_API_KEY
      : process.env.STRIPE_PUB_API_KEY,
  braintreePubKey:
    typeof window !== "undefined"
      ? window.BASE_CONFIG?.braintreePubApiKey ??
        process.env.BRAINTREE_PUB_API_KEY ??
        process.env.NEXT_PUBLIC_BRAINTREE_PUB_API_KEY
      : process.env.BRAINTREE_PUB_API_KEY,
};
